import Action from 'actions';
import BaseLP from 'services/sports/default/base-lp';
import Const from 'constants';

export default class LpTiers extends BaseLP {
    preparePlayerByLPPlayerId({incomingValues: {id}}) {
        const state = Action.getState();
        const {preparedPlayers} = state.playersData;
        const players = preparedPlayers.groupedBy.playerId();

        const unit = id.replace(Const.LP_UNIT_PREFIX, '').split(Const.LP_ITEM_DELIMITER);

        return {...players[unit[0]]};
    }

    createGroupsOfStacks({incomingValues: {dispatch}}) {
        const {
            playersData: {preparedPlayers},
        } = Action.getState();
        dispatch(Action.do('createGroupsOfPositionStacks', preparedPlayers.groupedBy.teamAndPosition()));
    }

    subjectToPermanent() {
        const constraints = {
            tiers: this.exec('prepareSectionByTier', {}, ''),
            games: this.exec('prepareSectionByGame', {addPositionToPID: true}, ''),
            keyPlayerStacking: this.exec(
                'keyPlayerStacking',
                {
                    checkIfPlayerOnDoublePosition: true,
                },
                '',
            ),
            projectionBoostRule: this.exec(
                'projectionBoostRule',
                {
                    checkIfPlayerOnDoublePosition: true,
                },
                '',
            ),
        };

        return {...constraints};
    }

    subjectToAlterable() {
        const constraints = {
            createdLineups: this.exec('prepareSectionByCreatedLineups_Tiers', {}, ''),
            multiPositions: this.exec('prepareSectionByMultiPositions', {}, ''),
            exposureMax: this.exec('prepareSectionByExposureMax', {}, ''),
            exposureMin: this.exec('prepareSectionByExposureMin', {}, ''),
            playerCombinationStacking: this.exec('playerCombinationStacking', {}, ''),
        };

        return {...constraints};
    }
}
